const menuContent = {
  title: '메뉴 관리 매뉴얼',
  content: `
  <div class="page-title">[메뉴 관리]</div>

# [개요]
메뉴 관리는 관리자 시스템의 메뉴 권한을 효율적으로 관리하기 위한 도구입니다. 이 문서에서는 **그룹별 메뉴 권한 설정 및 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 그룹 선택 | 권한을 설정할 그룹 선택 | 관리자 |
| 메뉴 권한 설정 | 선택된 그룹의 메뉴별 권한 설정 | 관리자 |
| 권한 저장 | 설정된 메뉴 권한 저장 | 관리자 |

# [화면 구성]
메뉴 관리 화면은 크게 좌측의 그룹 목록과 우측의 메뉴 트리로 구성됩니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 좌측 영역 | 그룹 목록 | • 권한 설정할 그룹 선택<br>• 그룹별 권한 현황 확인 |
| 우측 영역 | 메뉴 트리 | • 메뉴 구조 확인<br>• 체크박스로 권한 설정 |
| 버튼 영역 | 저장 버튼 | • 설정된 권한 저장 |

![메뉴 관리](/assets/images/guide/menu/list.png)

# [권한 설정]
그룹별 메뉴 권한을 설정하고 관리할 수 있습니다.

> ⚠️ **주의사항**
> - 상위 메뉴의 권한이 없으면 하위 메뉴도 접근할 수 없습니다.
> - 권한 변경 후 반드시 저장 버튼을 클릭해야 합니다.
> - 권한 변경 시 해당 그룹의 모든 사용자에게 영향을 미칩니다.

### 📋 권한 설정 방법
1. **그룹 선택**
   - 좌측 그룹 목록에서 권한을 설정할 그룹을 선택합니다.
   - 선택된 그룹의 현재 메뉴 권한이 우측에 표시됩니다.

2. **메뉴 권한 설정**
   - 우측 메뉴 트리에서 권한을 부여할 메뉴를 체크합니다.
   - 상위 메뉴 체크 시 하위 메뉴가 자동으로 체크됩니다.
   - 하위 메뉴만 선택적으로 체크할 수 있습니다.

3. **권한 저장**
   - 설정이 완료되면 저장 버튼을 클릭합니다.
   - 저장 즉시 해당 그룹의 권한이 변경됩니다.
  `,
};

export default menuContent;
